export default __webpack_public_path__ + "static/media/1.fa9e971f.png";